export var VectorType;
(function (VectorType) {
    VectorType[VectorType["FLAT"] = 0] = "FLAT";
    VectorType[VectorType["CONST"] = 1] = "CONST";
    VectorType[VectorType["SEQUENCE"] = 2] = "SEQUENCE";
    VectorType[VectorType["DICTIONARY"] = 3] = "DICTIONARY";
    VectorType[VectorType["FSST_DICTIONARY"] = 4] = "FSST_DICTIONARY";
})(VectorType || (VectorType = {}));
//# sourceMappingURL=vectorType.js.map